import {defineStore} from "pinia";
import FormAPI from "@/api/FormAPI";
import {
  utcToLocal,
} from "@/internal";

export const useStatusLogStore = defineStore('status-log', {
  state: () => ({
    data: [],
  }),
  actions: {
    clear() {
      this.data = [];
    },
    index(payload) {
      const { params } = payload;
      const { formId, ...rest } = params;

      return new FormAPI().statusLogs(formId, rest)
      .then((response) => {
        this.data = response.data.data.map((data) => {
          return {
            ...data,
            latest_email_sent_on: utcToLocal(data.latest_email_sent_on),
          };
        });
        return response;
      });
    },
    export(id, name, payload) {
      const { params } = payload;

      return new FormAPI().statusLogsExport(id, name, params)
        .then((response) => {
        });
    },
  },
  persist: true,
});
